'use client';

import { forwardRef } from 'react';

import type { PolymorphicForwardRefComponentV2 } from '../utils/types';
import styles from './visually-hidden.component.module.scss';

/**
 * コンテンツを見た目から隠すためのコンポーネント。支援技術が情報にアクセスできる状態を維持する
 */
export const VisuallyHidden = forwardRef((props, ref) => {
  const { className, children, ...rest } = props;
  return (
    <span
      className={[styles.visuallyHidden, className].filter(Boolean).join(' ')}
      ref={ref}
      {...rest}
    >
      {children}
    </span>
  );
}) as PolymorphicForwardRefComponentV2<'span', 'span' | 'p'>;

VisuallyHidden.displayName = 'VisuallyHidden';
